import React from 'react';

export default function DirectorIcon({ fill = '#1C274C', stroke = '#FFF', ...rest }: React.SVGProps<SVGSVGElement>) {
    return (
        <svg width="40px" height="40px" viewBox="0 0 512 512" fill="none" xmlns="http://www.w3.org/2000/svg" {...rest}>
            <g>
                <g>
                    <path
                        style={{ fill: '#ABB8B9' }}
                        d="M388.499,235.002H123.501H76.445c-3.913,0-7.111,3.199-7.111,7.11v28.447
                        c0,3.913,3.198,7.109,7.111,7.109H123.5h264.999h47.056c3.911,0,7.11-3.196,7.11-7.109v-28.447c0-3.91-3.199-7.11-7.11-7.11
                        L388.499,235.002L388.499,235.002z"
                    />
                    <path
                        style={{ fill: '#ABB8B9' }}
                        d="M123.501,138.667h264.999h32.833c11.734,0,21.333-9.598,21.333-21.332V53.334V32.003
                        c0-11.735-9.599-21.336-21.333-21.336H90.666c-11.734,0-21.333,9.601-21.333,21.336v63.997v21.335
                        c0,11.733,9.599,21.332,21.333,21.332H123.501L123.501,138.667z M256,42.668l12.901,17.617l20.746,6.827l-12.769,17.716
                        l-0.085,21.838L256,99.996l-20.794,6.671l-0.084-21.838l-12.77-17.716l20.746-6.827L256,42.668z"
                    />
                </g>
                <polygon
                    style={{ fill: '#ED8C18' }}
                    points="235.205,106.667 256,99.996 276.793,106.667 276.878,84.829 289.647,67.112 268.9,60.285 
                    256,42.668 243.098,60.285 222.352,67.112 235.121,84.829 	"
                />
            </g>
            <g>
                <path
                    style={{ fill: fill }}
                    d="M421.333,0H90.666c-17.645,0-32,14.356-32,32.003v85.332c0,17.644,14.355,31.999,32,31.999h22.166
                    v75H76.445c-9.802,0-17.778,7.975-17.778,17.777v28.447c0,9.802,7.975,17.776,17.778,17.776h43.516l118.192,88.117L82.123,492.78
                    c-4.724,3.521-5.699,10.204-2.176,14.928c2.095,2.809,5.307,4.292,8.56,4.292c2.218,0,4.455-0.689,6.368-2.115L256,389.757
                    l161.124,120.127c1.915,1.427,4.151,2.115,6.368,2.115c3.254,0,6.467-1.483,8.56-4.292c3.522-4.724,2.548-11.407-2.175-14.928
                    l-156.03-116.328l118.191-88.117h43.518c9.801,0,17.777-7.975,17.777-17.776v-28.447c0-9.802-7.976-17.777-17.777-17.777h-36.389
                    v-75h22.166c17.645,0,32-14.354,32-31.999V32.003C453.333,14.356,438.978,0,421.333,0z M256,363.145l-100.344-74.812h200.69
                    L256,363.145z M431.998,266.999H80.001v-21.33h351.997V266.999z M377.832,224.334H134.168v-75h243.664L377.832,224.334
                    L377.832,224.334z M421.333,128H90.666c-5.882,0-10.665-4.783-10.665-10.664v-10.667h28.994c5.893,0,10.667-4.776,10.667-10.667
                    s-4.775-10.667-10.667-10.667H80.001v-53.33c0-5.883,4.783-10.669,10.665-10.669h330.666c5.881,0,10.665,4.785,10.665,10.669
                    v10.663h-28.994c-5.892,0-10.667,4.776-10.667,10.667s4.776,10.667,10.667,10.667h28.994v53.334
                    C431.998,123.216,427.214,128,421.333,128z"
                />
                <path
                    style={{ fill: fill }}
                    d="M292.982,56.979l-17.495-5.757l-10.882-14.857c-2.009-2.744-5.205-4.364-8.604-4.364
                    c-3.4,0-6.598,1.62-8.606,4.364l-10.882,14.857l-17.495,5.757c-3.23,1.064-5.759,3.602-6.811,6.837
                    c-1.051,3.234-0.497,6.775,1.491,9.533l10.769,14.942l0.071,18.417c0.014,3.401,1.647,6.59,4.398,8.589
                    c1.845,1.34,4.045,2.036,6.27,2.036c1.091,0,2.192-0.167,3.258-0.51L256,111.199l17.535,5.626c3.238,1.039,6.777,0.472,9.528-1.527
                    c2.752-1.998,4.385-5.189,4.398-8.589l0.071-18.418l10.769-14.942c1.988-2.759,2.542-6.299,1.491-9.533
                    C298.741,60.581,296.211,58.043,292.982,56.979z M268.224,78.592c-1.3,1.804-2.004,3.971-2.013,6.196l-0.028,7.272l-6.924-2.221
                    c-1.06-0.34-2.159-0.51-3.259-0.51c-1.1,0-2.201,0.171-3.259,0.51l-6.925,2.221l-0.027-7.272c-0.01-2.224-0.713-4.391-2.015-6.196
                    l-4.252-5.9l6.909-2.274c2.113-0.696,3.957-2.034,5.271-3.83L256,60.721l4.297,5.867c1.314,1.795,3.158,3.134,5.271,3.83
                    l6.908,2.274L268.224,78.592z"
                />
                <path
                    style={{ fill: fill }}
                    d="M372.359,42.671h-0.256c-5.891,0-10.667,4.776-10.667,10.667s4.777,10.667,10.667,10.667h0.256
                    c5.892,0,10.667-4.776,10.667-10.667S378.25,42.671,372.359,42.671z"
                />
                <path
                    style={{ fill: fill }}
                    d="M139.898,85.337h-0.256c-5.892,0-10.667,4.777-10.667,10.667c0,5.892,4.777,10.667,10.667,10.667
                    h0.256c5.892,0,10.667-4.776,10.667-10.667C150.565,90.114,145.789,85.337,139.898,85.337z"
                />
            </g>
        </svg>
    );
}
